import React, { useState, useEffect, useRef } from "react";
import { Suspense, lazy } from 'react';
import "./App.css";
import ReactGA from 'react-ga';

import fullpage from './background/Fullpage.png'
import onepage from './background/OnePage(Wider).png'

import Loadingscreen from "./containers/Loadingscreen";
const Navigation = lazy(()=>import('../src/Config/Navigation'));
// import Navigation from "../src/Config/Navigation";


const images =[fullpage, onepage]

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    ReactGA.initialize('UA-185669177-1');
    ReactGA.pageview(window.location.pathname);
    ReactGA.modalview(window.location.pathname)

    const loadImage = image => {
      return new Promise((resolve, reject) => {
        const loadImg = new Image()
        const oneImg = new Image()
        loadImg.src = fullpage
        oneImg.src = onepage
        // wait 2 seconds to simulate loading time
        loadImg.onload = () =>{
            resolve(loadImg.src)
          }

        loadImg.onerror = err => reject(err)
      })
    }

    loadImage()
      .then(() => {console.log("f")
    setLoading(true)
    })
      .catch(err => console.log("Failed to load images", err))
  }, []);

  return (
    <>

<div className={!loading ? "loadingbg" : "App"}>
<Suspense fallback={<Loadingscreen />}>
     <Navigation />
    </Suspense>
    </div>
  </>
  );
}

export default App;
